import { useCandidateNavigationOptional } from '@components/contexts/CandidateNavigationContext';

export type PromptBarMode = 'search' | 'chat';

/**
 * Derives the prompt bar mode from the current candidate view: **search** only on the job-search
 * form (`new-job-search-form`, i.e. /mc/search) and its results (`candidateSearch` /
 * `editSearch` / `keyword`); **chat** on everything else (coaching, landings, company pages,
 * unknown). Context is NOT consulted — a company viewing /mc/search must still get search mode.
 *
 * `override` lets a caller force a mode (e.g. company leaf pages that render a chat-only pill,
 * or pages where CandidateNavigationProvider is not mounted).
 */
export const usePromptBarMode = (override?: PromptBarMode): PromptBarMode => {
  const candidateNav = useCandidateNavigationOptional();
  if (override) return override;

  const view = candidateNav?.currentView;
  const isJobSearch = view === 'new-job-search-form'
    || (typeof view === 'object' && view !== null
      && ('candidateSearch' in view || 'editSearch' in view || 'keyword' in view));

  return isJobSearch ? 'search' : 'chat';
};
